module.exports = __webpack_public_path__ + "img/default_doctor_image.b44f0eda.png";